const casesStatsInit = () => {
  const posts = document.querySelectorAll(".cases-stats__card");

  gsap.registerPlugin(ScrollTrigger);

  if (posts) {
    posts.forEach((span, i) => {
      gsap.from(span, {
        opacity: 0,
        y: "100px",
        delay: i * 0.2,
        scrollTrigger: {
          trigger: span,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  casesStatsInit();
});
